import { apiUrl }  from "../constants";
var axios = require('axios');
var request = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization':localStorage.getItem('token'),'Content-Type':'application/json'}
})
export default class MatchesApi {
    static getAll() {
        return request.get(`/matches/${localStorage.getItem("rol")}`);
    }

    static getFiltered(string){
        return request.get(`/matches/${localStorage.getItem("rol")}?${string}`);
    }

    static get(id){
        return request.get(`/matches/${localStorage.getItem("rol")}/${id}`)
    }

    static matchForm(id){
        return request.get(`/matches/${localStorage.getItem("rol")}?match_id=${id}&user_id=${localStorage.getItem("id")}&cedula=1`)
    }

    static create(match) {
        return request.post('/matches',{match: match });
    }

    static edit(match, id){
        return request.put(`/matches/${id}`, {match: match});
    }

    static delete(id){
        return request.delete(`matches?id=${id}`);
    }
}


// WEBPACK FOOTER //
// ./src/api/Matches.js